export const STYLIST_CARD_DESCRIPTION_CLASS =
    "invisble text-sm md:text-lg italic font-medium  text-Text_White font-Poppins hover:visible";
